import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import {fireInit} from './helpers/firebaseHelpers'
import vuefire from 'vuefire'

import App from './App'
import Movie from './components/Movie'
import Movies from './components/Movies'
import About from './components/About'




// use router
Vue.use(VueRouter)


// meta information of the head tag
Vue.use(VueHead)


// firebase
Vue.use(vuefire)
fireInit()



// routes
const routes = [

  // to do: can we merge everything ? 

  { path: '/', component: Movies, name: 'home',
	
    children: [
        //an empty path will be treated as the default, e.g.
        //components rendered at /parent: Root -> Parent -> Default
        { path: '/about', component: About},
      ]
  },  
  { path: '/genre/:genre', component: Movies, name: 'genre',
  
    children: [
        //an empty path will be treated as the default, e.g.
        //components rendered at /parent: Root -> Parent -> Default
        { path: '/about', component: About},
      ]
  },
  { path: '/movie/:slug', component: Movies, name:'movie',
  
    children: [
        //an empty path will be treated as the default, e.g.
        //components rendered at /parent: Root -> Parent -> Default
        { path: '/about', component: About},
      ]
  },

  { path: '/admin', component: Movies, name:'admin' },

	{ path: '*', redirect: '/' },
]

// routing
const router = new VueRouter({
  mode: 'history',
  //base: __dirname,
  routes // short for routes: routes
})



const app = new Vue({
  template: '<App/>',
  components: { App } ,
  router
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js